import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import cls from './styles.scss'
import Text from '../../elementals/text'

const cx = classnames.bind(cls)

const AddressInfo = ({ address, elmId, className, isCancelled = false }) => {
  const addressArray = address || []
  const addressLine1 = addressArray[0]
  const addressLine2 = addressArray[1]
  const textBodyProps = {
    weight: 'normal',
    color: 'gray',
  }
  return (
    <div className={cx('address-container')}>
      <Text.Body
        as='h3'
        size='small'
        {...textBodyProps}
        data-elm-id={`address_line_1_${elmId}`}
        className={cx('property-address-line-1', className)}
      >
        {!isCancelled ? addressLine1 : ''}
      </Text.Body>

      <Text.Body
        as='h3'
        size='small'
        {...textBodyProps}
        data-elm-id={`address_line_2_${elmId}`}
        className={cx('property-address-line-2', className)}
      >
        {addressLine2}
      </Text.Body>
    </div>
  )
}

AddressInfo.propTypes = {
  address: PropTypes.array,
  elmId: PropTypes.string,
  className: PropTypes.string,
  isCancelled: PropTypes.bool,
}

export default AddressInfo
